import React, { useEffect, useState } from "react";
import PublicationProvider from "../context/PublicationProvider";
import { ButtonsRight } from "../interfaces/UI";
import LeftMenu from "./book/LeftMenu/LeftMenu";
import MidSection from "./book/MidSection/MidSection";
import RightSection from "./book/RightMenu/RightSection";
import LibroLoader from "./LibroLoader";
import { isDesktop } from "react-device-detect";
import { typeLibro } from "../interfaces/Publication";
import { Portal } from "./book/RightMenu/Portal";
import CalificaTuExperiencia from "./book/RightMenu/ModalCalificacion";
import { useUser } from "../hooks";

interface LibroProps {
  id: string;
  chapterNumber: number;
  typeLibro: typeLibro;
}

const Libro = ({ id, chapterNumber, typeLibro }: LibroProps) => {
  const [showCalificacion, setShowCalificacion] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [userHasRated, setUserHasRated] = useState<boolean | null>(null);
  const { user } = useUser();

  const [viewButtons] = useState<ButtonsRight>({
    optConfig: true,
    optIndex: true,
    optNotes: false,
    optFileDoc: true,
    optReviews: false,
    optHelp: true,
    optPodcast: true,
  });

  const [openButtons, setOpenButtons] = useState<ButtonsRight>({
    optConfig: false,
    optIndex: false,
    optNotes: false,
    optFileDoc: false,
    optReviews: false,
    optHelp: false,
    optAuthor: false,
  });

  useEffect(() => {
    const backdrop = document.querySelector(".backdrop-m");
    const rightNav = document.querySelector(".gui__group--right");
    if (!backdrop || !rightNav) return;

    const isAnyOpen = Object.values(openButtons).some(Boolean);

    if (!isDesktop && isAnyOpen) {
      backdrop.classList.add("visible-fadein");
      rightNav.classList.add("show");
    } else {
      backdrop.classList.remove("visible-fadein");
      rightNav.classList.remove("show");
    }
  }, [openButtons]);

  const handleCloseCalificacion = () => {
    setShowCalificacion(false);
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  const checkIfUserHasRated = async () => {
    if (!user) return false;

    try {
      const response = await fetch(
        `https://apivirtualplant.com/apiVpro/public/api/getValoracionUnity?fvu_id_recurso=${id}&fvu_email=${user.sus_email}`
      );

      if (!response.ok) {
        throw new Error(`Error en la respuesta: ${response.status}`);
      }

      const data = await response.json();
      return Array.isArray(data) && data.length > 0;
    } catch (error) {
      console.error("Error al verificar calificación:", error);
      return false;
    }
  };

  useEffect(() => {
    // todavía no sabemos si calificó
    if (userHasRated === null) return;

    // si ya calificó, no hacemos nada
    if (userHasRated === true) return;

    const timeoutId = setTimeout(() => {
      setShowCalificacion(true);
    }, 10 * 60 * 1000); // 10 minutos

    return () => clearTimeout(timeoutId);
  }, [userHasRated]);

  useEffect(() => {
    if (!user) return;

    setUserHasRated(null);

    const verifyRating = async () => {
      const rated = await checkIfUserHasRated();
      setUserHasRated(rated);
    };

    verifyRating();
  }, [user]);

  return (
    <PublicationProvider>
      <LibroLoader
        id={id}
        chapterNumber={chapterNumber}
        typeLibro={typeLibro}
      />

      <div className="l1-wrapper">
        <LeftMenu />
        <MidSection
          viewButtons={viewButtons}
          openButtons={openButtons}
          setOpenButtons={setOpenButtons}
        />
        <RightSection
          viewButtons={viewButtons}
          openButtons={openButtons}
          setOpenButtons={setOpenButtons}
          typeLibro={typeLibro}
        />
        {showCalificacion && (
          <Portal>
            <CalificaTuExperiencia
              onClose={handleCloseCalificacion}
              setShowNotification={setShowNotification}
            />
          </Portal>
        )}
      </div>
    </PublicationProvider>
  );
};

export default Libro;
